import { render } from "./AppMenu.vue?vue&type=template&id=4a694403&scoped=true&lang=pug"
import script from "./AppMenu.vue?vue&type=script&lang=js"
export * from "./AppMenu.vue?vue&type=script&lang=js"

import "./AppMenu.vue?vue&type=style&index=0&id=4a694403&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a694403"]])

export default __exports__